export default __webpack_public_path__ + "static/media/94_mobile.91ac40b2.jpg";